import React from "react";
import PropTypes from "prop-types";

// Style
import {Error} from "../../style/components/general";

const VisibilityConflictWarning = ({conflicts = []}) =>
  conflicts.map(({restrictionLabel, memberName}) => (
    <Error key={`${restrictionLabel}-${memberName}`} data-testid="checksheet.visibilityConflict">
      {`${memberName} is on the ${restrictionLabel} restriction but cannot open this checksheet.`}
    </Error>
  ));

VisibilityConflictWarning.propTypes = {
  conflicts: PropTypes.arrayOf(
    PropTypes.shape({
      restrictionLabel: PropTypes.string,
      memberName: PropTypes.string
    })
  )
};

export default VisibilityConflictWarning;
